



















import Vue from 'vue';
import Component from 'vue-class-component';
import LoadingAnimation from 'frontend/components/LoadingAnimation.vue';
import Modal from 'frontend/components/Modal.vue';
import BriocheImageTag from 'frontend/components/BriocheImageTag.vue';

@Component({
  components: {
    LoadingAnimation,
    BriocheImageTag,
    Modal,
  },
  computed: {},
})
export default class NovaSponsorModal extends Vue {
  private showModal = false;
  private sponsorLogo = '/site_media/version-555b1541d7/images/sponsorship/nova.png';

  private async handleCloseModal() {
    this.showModal = false;
  }

  private mounted() {
    this.showModal = true;
  }
}
